import barchart from './barchartUtils'
import linechart from './linechartUtils'
import piechart from './piechartUtils'
import stackedbarchart from './stackedbarchartUtils'
import groupedbarchart from './groupedbarchartUtils'
import * as map from './mapUtils'
import pyramidchart from './pyramidchartUtils'

import heatmap from './heatmapUtils'
import treemap from './treemapUtils'
import radarchart from './radarchartUtils'
import connecteddotplot from './connecteddotplotUtils'

export function isNombre(id) {
  return (
    String(id).toLowerCase().trim() === 'nombre' ||
    String(id).toLowerCase().trim() === 'número' ||
    String(id).toLowerCase().trim() === 'number'
  )
}
export function isPercentatge(id) {
  return (
    String(id).toLowerCase().trim() === 'percentatge' ||
    String(id).toLowerCase().trim() === 'porcentaje' ||
    String(id).toLowerCase().trim() === 'percent'
  )
}

export function isSexe(id) {
  return (
    String(id).toLowerCase().trim() === 'sexe' ||
    String(id).toLowerCase().trim() === 'sexo' ||
    String(id).toLowerCase().trim() === 'sex'
  )
}

export function isHomes(id) {
  return (
    String(id).toLowerCase().trim() === 'home' ||
    String(id).toLowerCase().trim() === 'hombre' ||
    String(id).toLowerCase().trim() === 'male'
  )
}

export function isDones(id) {
  return (
    String(id).toLowerCase().trim() === 'dona' ||
    String(id).toLowerCase().trim() === 'mujer' ||
    String(id).toLowerCase().trim() === 'female'
  )
}

export function isAddable(id) {
  return isNombre(id) || isPercentatge(id)
}

export const chartUtils = {
  'bar-chart': barchart,
  'line-chart': linechart,
  'pie-chart': piechart,
  'stacked-chart': stackedbarchart,
  'grouped-chart': groupedbarchart,
  map: map,
  'pyramid-chart': pyramidchart,
  'heat-map': heatmap,
  'tree-map': treemap,
  'radar-chart': radarchart,
  'connected-dotplot': connecteddotplot,
}

import { maskValue } from '@/utils/formatUtils'
import dayjs from 'dayjs'

export function statsSdvTooltipFunction(d, key, self, date) {
  let timeLabel = !isNaN(dayjs(d.id))
    ? dayjs(d.id).format('DD/MM/YYYY')
    : date
    ? dayjs(date).format('DD/MM/YYYY')
    : ''
  let color = self.color(d.parentId ? { id: d.parentId } : d)
  return `
    <div class="tip-value">${d.value}</div>
    <div class="tip-id">
      <span class="icon" style="background: ${color}; display:${
    color ? 'inline-block' : 'none'
  }"></span>
      ${d.parentId ? d.parentId : d.id}
    </div>
    <div class="tip-time">${timeLabel}</div>
  `
}

export function sdvTooltipFunction(
  d,
  key,
  self,
  dataCard,
  internalPivotConfig,
  dimensionMetas,
  dimensionOptions,
  flatDimensionsOptions
) {
  let timeDim = internalPivotConfig.dimensions.find(d => {
    return dimensionMetas[d.id]?.type === 'time'
  })
  let timeOptions = flatDimensionsOptions[timeDim.id].filter(o => o.type)
  let currentTimeValue = timeOptions.find(o => o.id === timeDim.values[0].value)
  console.log("currentTimeValue:", currentTimeValue)
  let filterDim = internalPivotConfig.dimensions.filter(dim => dim.role === 'filters')
  let computedStringFilters = ''
  let arrayStringFilters = []
  let filterName
  filterDim.forEach(filt => {
    filterName = dimensionMetas[filt.id].label
    computedStringFilters =
      filterName.charAt(0).toUpperCase() +
      filterName.slice(1) +
      ' ' +
      flatDimensionsOptions[filt.id].find(el => el.id === filt.values[0].value).label
    arrayStringFilters.push(computedStringFilters)
  })
  computedStringFilters = arrayStringFilters.join(', ')

  const selectedTimeTypeId = timeDim?.values?.[0]?.value

  const selectedTypePrefix =
    typeof selectedTimeTypeId === 'string'
      ? selectedTimeTypeId.split('_').slice(0, 2).join('_') + '_'
      : null

  let timeLabelFound = null
  if (selectedTypePrefix && d.id instanceof Date) {
    const iso = dayjs(d.id).utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]')
    const expectedId = `${selectedTypePrefix}${iso}`

    timeLabelFound = timeOptions.find(o => o.id === expectedId) || null
  }

  console.log("selectedTimeTypeId:", selectedTimeTypeId)

  let color = self.color(d.parentId ? { id: d.parentId } : d)

  const isYear = currentTimeValue?.id?.toLowerCase?.().includes('_any_')
  const isMonth = currentTimeValue?.id?.toLowerCase?.().includes('_mes_')

  let formattedTime = ''

  if (d.id instanceof Date) {
    formattedTime = isMonth
      ? dayjs(d.id).format('MMM YYYY')
      : isYear
      ? dayjs(d.id).format('YYYY')
      : dayjs(d.id).format('DD MMM YYYY')
  }

  console.log("d:", d)

  const categoryLabel = d.parentId ? d.parentId : d.id
  const timeToShow = timeLabelFound?.label || formattedTime || (d.parentId ? d.id : ' ')
  console.log("timeLabelFound?.label:", timeLabelFound?.label)
  console.log("formattedTime:", formattedTime)
  console.log("d.id:", d.id)
  console.log("timeToShow:", timeToShow)

  console.log(computedStringFilters)

  return `
  <div class="tip-value">${maskValue(d.value, dataCard)}</div>
  <div class="tip-filters">${computedStringFilters}</div>

  <!-- Bloque de tiempo -->
  <div class="tip-time">${timeToShow}</div>

  <!-- Bloque de categoría -->
  <div class="tip-id">
    <span class="icon" style="background: ${color}; display:${color ? 'inline-block' : 'none'}"></span>
    ${categoryLabel}
  </div>
`

}
export default chartUtils
